import React, { useState } from "react";
import TaxForm from "./TaxForm";

export default function TaxTab({
  taxes,
  onAdd,
  onUpdate,
  onRemove,
}) {
  const [editingIndex, setEditingIndex] =
    useState(null);

  return (
    <div className="erp-section">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        <div className="erp-section-title">
          Tax Registrations
        </div>

        <button
          className="btn btn-sm btn-primary"
          onClick={() => setEditingIndex(-1)}
        >
          + Add Tax
        </button>
      </div>

      {editingIndex !== null && (
        <TaxForm
          initialData={
            editingIndex >= 0
              ? taxes[editingIndex]
              : null
          }
          onCancel={() => setEditingIndex(null)}
          onSave={(data) => {
            if (editingIndex >= 0) {
              onUpdate(editingIndex, data);
            } else {
              onAdd(data);
            }
            setEditingIndex(null);
          }}
        />
      )}

      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>Type</th>
            <th>Registration No</th>
            <th>State</th>
            <th>Active</th>
            <th width="140">Action</th>
          </tr>
        </thead>

        <tbody>
          {taxes.length === 0 && (
            <tr>
              <td
                colSpan={5}
                className="text-center text-muted"
              >
                No tax registrations added
              </td>
            </tr>
          )}

          {taxes.map((t, i) => (
            <tr key={i}>
              <td>{t.tax_type}</td>
              <td>{t.registration_no}</td>
              <td>{t.state_code}</td>
              <td>{t.is_active ? "✔" : ""}</td>
              <td>
                <button
                  className="btn btn-sm btn-outline-primary me-2"
                  onClick={() =>
                    setEditingIndex(i)
                  }
                >
                  Edit
                </button>

                <button
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => onRemove(i)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
